var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.972a.99.99 0 0 1-.5.846v2.154H8v-2.153a.98.98 0 0 1-.5-.847 1 1 0 1 1 2 0m5.465-2.512v7.08c0 .827-.673 1.5-1.5 1.5H3.476c-.827 0-1.5-.673-1.5-1.5V8.46c0-.827.673-1.5 1.5-1.5H3.5V4.972c0-2.757 2.243-5 5-5s5 2.243 5 5v1.992a1.5 1.5 0 0 1 1.465 1.496M4.5 6.96h8V4.972c0-2.206-1.794-4-4-4s-4 1.794-4 4zm9.465 1.5a.497.497 0 0 0-.465-.493v.004h-10V7.96h-.024a.5.5 0 0 0-.5.5v7.08a.5.5 0 0 0 .5.5h9.989a.5.5 0 0 0 .5-.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.svg";